import React, { FunctionComponent, useState } from 'react'
import Stop from '../assets/images/stop.png'
import IconHoldingPhone from '../assets/images/icon-holding-phone.png'
import Map from '../assets/images/map.svg'
import { connect } from 'react-redux'
import { Callback } from '../utils/types'
import { Redirect, withRouter } from 'react-router-dom'
import { User, Vehicle } from '../core/types'
import { compose } from 'redux'

import {
  setCreditSessionFinished,
  setRefiAppCreditStepState,
  toggleCoverageUiState,
  setRefiAppRejectedCreditAppState,
} from '../features/refiApp/refiActions'
import { createProductPackage } from '../features/refiApp/productPackageActions'
import { selectCurrentRefiVehicle, selectCurrentRefiUser } from '../reducers'
import { onContinueWithoutCredit } from '../features/refiApp/credit/creditApplicationChoice'

interface Props {
  setRefiAppCreditStepState: Callback
  toggleCoverageUiState: Callback
  setCreditSessionFinished: Callback
  createProductPackage: Callback
  setRefiAppRejectedCreditAppState: Callback
  // continuation thunk: (user, productPackageId, history) => Promise<void>
  onContinueWithoutCredit: Callback<Promise<void>>
  user: User
  vehicle: Vehicle
  location: any
  history: any
}

const RefiStatusView: FunctionComponent<Props> = ({
  onContinueWithoutCredit,
  vehicle,
  user,
  location,
}) => {
  const [loading, setLoading] = useState(false)
  const [redirect, setRedirect] = useState(false)

  const onClick = async () => {
    setLoading(true)
    await onContinueWithoutCredit(user, vehicle)
    setLoading(false)
    setRedirect(true)
  }

  if (redirect) {
    return <Redirect to="/refiapp" />
  }
  const viewType = location.pathname.split('/').pop()

  let title
  let content
  let imageSource

  switch (viewType) {
    case 'pending':
      title = "Sorry, we couldn't find your credit history."
      content = (
        <p className="status-view__content">
          If the consumer has further questions they can reach out to Blinker at
          844-854-0805.
        </p>
      )
      imageSource = IconHoldingPhone
      break
    case 'rejected':
      title = "Sorry, we couldn't get you a quote."
      content = (
        <p className="status-view__content">
          The consumer will be notified of the specific reason why they were
          unable to qualify for refinancing by the lender. If the consumer has
          further questions they can reach out to Blinker at 844-854-0805.
        </p>
      )
      imageSource = Stop
      break
    case 'unavailable':
      title = 'This feature will be available soon.'
      content = (
        <p>
          We are working to bring our fantastic refinance platform to your
          state, too. We can’t wait to help you spend less and drive happy soon!
        </p>
      )
      imageSource = Map
      break
    default:
      title = 'Something went wrong!'
      content = (
        <p>
          This case shouldn't be acessed.
          <br />
          If you were redirected here, please
          <br />
          contact tech support!
        </p>
      )
      imageSource = Map
      break
  }

  return (
    <div className="status-view__main">
      <div className="status-view">
        <img className="status-view__img" src={imageSource} alt="" />
        <div className="status-view__container">
          <h2 className="status-view__title">{title}</h2>
          {content}
          {viewType && (
            <div className="status-view__button-container">
              <button className="button" onClick={onClick}>
                {loading ? 'Loading...' : 'Continue with VSC options'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export const mapStateToProps = (state) => ({
  vehicle: selectCurrentRefiVehicle(state),
  user: selectCurrentRefiUser(state),
})

const mapDispatchToProps = {
  setRefiAppCreditStepState,
  toggleCoverageUiState,
  setCreditSessionFinished,
  createProductPackage,
  setRefiAppRejectedCreditAppState,
  onContinueWithoutCredit,
}

export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(RefiStatusView) as React.ComponentType<Props>
